import NotFound from '@/components/notFound';
import Spinner from '@/components/spinner';
import { AuthProvider, useAuth } from '@/lib/auth';
import { createRootRoute, Navigate, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';

export const Route = createRootRoute({
  component: () => <AppRoot />,
  notFoundComponent: () => <NotFound />,
});

function RootRedirect() {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <Spinner />;
  }

  if (user) {
    return <Navigate to="/dashboard" />;
  }

  return <Navigate to="/login" />;
}

export default function AppRoot() {
  return (
    <AuthProvider>
      <RootRedirect />
      <Outlet />
      {import.meta.env.DEV && (
        <TanStackRouterDevtools position="bottom-right" />
      )}
    </AuthProvider>
  );
}
